module.exports = __webpack_public_path__ + "assets/img/solutions1.b4fd8eac.png";